module.exports = __webpack_public_path__ + "static/xanathar-mtg_afr-c41b954c36d09787d1d4654cb9c2abe6.jpg";